import { Form, Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login, setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';
import axios from 'axios';
import { ensureCsrfCookie } from '../general/axiosInstance';
import logo from '../../images/logo.png';

function Login(props) {
  const { isLoggedIn, login, setIsLoading } = props;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const [alertModalShow, setAlertModalShow] = useState(false);
  const [alertModalMsg, setAlertModalMsg] = useState('');

  useEffect(() => {
    setIsLoading(false);
    if (isLoggedIn) navigate('/main');
  }, [isLoggedIn]);

  const loginOnServer = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      ensureCsrfCookie()
        .then(() => axios.post('/login', { email, password }))
        .then(response => {
          setIsLoading(false);
          login(response.data.user);
          navigate('/main');
        })
        .catch(error => {
          setIsLoading(false);
          setAlertModalShow(true);
          if (error?.response?.status === 401) {
            setAlertModalMsg('Usuario o contraseña incorrecto');
          } else if (error.code === 'ERR_NETWORK') {
            setAlertModalMsg('No hay conexión a internet');
          } else {
            setAlertModalMsg('Error desconocido: ' + error.message);
          }
        });
    } catch (error) {
      setIsLoading(false);
      setAlertModalShow(true);
      setAlertModalMsg(error.message);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src={logo} height="44" alt="Abi" className="rounded" />
        </div>
        <div className="auth-title">Bienvenido a Abi</div>
        <div className="auth-subtitle">Ingresa tus credenciales para continuar</div>

        <Form onSubmit={loginOnServer}>
          <Form.Group className="mb-3">
            <Form.Label className="report-field-label">Correo electrónico</Form.Label>
            <div className="auth-input-wrap">
              <i className="fa fa-envelope auth-input-icon" />
              <Form.Control
                type="email"
                placeholder="correo@entidad.com"
                autoComplete="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="report-field-label">Contraseña</Form.Label>
            <div className="auth-input-wrap">
              <i className="fa fa-lock auth-input-icon" />
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                autoComplete="current-password"
                style={{ paddingRight: 38 }}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="auth-input-toggle"
                onClick={() => setShowPassword(v => !v)}
                tabIndex={-1}
              >
                <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} />
              </button>
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Check
              type="checkbox"
              id="remember-me"
              label="Recuérdame"
              className="auth-checkbox"
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 auth-submit-btn">
            <i className="fa fa-sign-in" /> Ingresar
          </Button>
        </Form>

        <div className="auth-divider">
          <Link to="/recover-password" style={{ color: 'var(--abi-primary)', fontWeight: 600, fontSize: 13 }}>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <Link to="/home" style={{ color: 'var(--abi-muted)', fontSize: 13 }}>
            ← Regresar al inicio
          </Link>
        </div>
      </div>

      <AlertModal show={alertModalShow} setShow={setAlertModalShow} msg={alertModalMsg} />
    </div>
  );
}

function mapStateToProps(state) {
  return { username: state.username, isLoggedIn: state.isLoggedIn };
}

const mapDispatchToProps = { login, setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(Login);
